import React from 'react';
import { useState } from 'react';
import "./index.css";
import "./mobile.css";

function Minesweeper({ text, indexNumber, left, top, imageSource, heading,closeFunction,moveFunction,upFunction,downFunction,zIndex }) {
    const tiles = [];
    const [isStillPlaying,SetIsStillPlaying] = useState(true);
    const resetMinesweeper = () => { 
        let tilesRender = Array.prototype.slice.call(document.getElementsByClassName("tile"));
        for(let i=0;i<tilesRender.length;i++){
            tilesRender[i].style.backgroundImage = "none";
            tilesRender[i].classList = "tile bordered";
            tilesRender[i].innerHTML = "";
        }
        SetIsStillPlaying(true);
    }
    const logTile = (e) => { 
        if(isStillPlaying){
            fillOutTileDistances(e.target.id.split("minesweeper-grid-id-")[1]);
            e.target.style.backgroundImage = "url(./images/programs/minesweeper.png)";
            e.target.innerHTML = "";
            SetIsStillPlaying(false);
        }
    }

    const fillOutTileDistances = (clickedElement) => {
        let row = Number(clickedElement.split("-")[0]);
        let column = Number(clickedElement.split("-")[1]);
        let tilesRender = Array.prototype.slice.call(document.getElementsByClassName("tile"));
        for(let i=0;i<tilesRender.length;i++){
            tilesRender[i].classList = "tile opened-tile";          
        }
        let tilesToShow = [];
        tilesToShow.push((row - 1) + "-" + column);
        tilesToShow.push((row + 1) + "-" + column);
        tilesToShow.push((row) + "-" + (column - 1));
        tilesToShow.push((row) + "-" + (column + 1));
        tilesToShow.push((row - 1) + "-" + (column - 1));
        tilesToShow.push((row - 1) + "-" + (column + 1));
        tilesToShow.push((row + 1) + "-" + (column - 1));
        tilesToShow.push((row + 1) + "-" + (column + 1));
        for(let i=0;i<tilesToShow.length;i++){
            let elem = document.getElementById("minesweeper-grid-id-" + tilesToShow[i]);
            if(elem){elem.innerHTML = "1"}
        }
    }
  
    for (let i = 1; i < 8; i++) {
      for(let x=1;x<8;x++){
        let id = 'minesweeper-grid-id-' + i + "-" + x;
        tiles.push(<div id={id} className="tile bordered" onClick={logTile}></div>);
      }
    }
    return (
        <div className="dialog-box minesweeper" id={indexNumber} 
        style={{ left: left, 
            top: top, 
            zIndex:zIndex
        }}
        onMouseMove={moveFunction}
        onMouseUp={upFunction}
        data-boxindex={indexNumber}
        >
            <div className="dialog-box-heading big-text draggable-box"
             onMouseDown={downFunction}
             data-boxindex={indexNumber}
            >
                <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
                    <img className="heading-image draggable-box" src={imageSource} alt="heading" data-boxindex={indexNumber}/>
                    <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
                </div>
                <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={()=>{closeFunction(indexNumber)}} />
            </div>
            <div className="minesweeper-body small-text">
                <div className='minesweeper-detail-wrapper'>
                <img className='minesweeper-scoreboard' src='./images/UI/minesweeper-scoreboard.png' alt='minesweeper-scoreboard'></img>
                <div id='minesweeper-face' className='bordered' onClick={isStillPlaying ? null : resetMinesweeper}><img src={isStillPlaying ? './images/UI/minesweeper-success.png' : './images/UI/minesweeper-failure.png'} alt='minesweeper'/></div>
                <img className='minesweeper-scoreboard' src='./images/UI/minesweeper-scoreboard.png' alt='minesweeper-scoreboard'></img>
                </div>
                <div className='minesweeper-grid'>
                {tiles}
                </div>
            </div>
        </div>
    );
}

export default Minesweeper;
